import React, { useEffect } from "react"
import { StyleSheet } from "react-native"
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated"
import { BFColors } from "@/constants/Colors"

interface CustomTabIconProps {
  isActive: boolean
  label: string
}

const ActiveTabIndicator: React.FC<CustomTabIconProps> = ({ isActive }) => {
  const width = useSharedValue(1)

  useEffect(() => {
    width.value = withTiming(isActive ? 26 : 0, {
      duration: isActive ? 310 : 155,
    })
  }, [isActive])

  const animatedStyle = useAnimatedStyle(() => ({
    width: width.value,
  }))

  return <Animated.View style={[styles.activeTabIndicator, animatedStyle]} />
}

const styles = StyleSheet.create({
  activeTabIndicator: {
    marginTop: 4,
    height: 2,
    backgroundColor: BFColors.calmBlue,
  },
})

export default ActiveTabIndicator
